/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dateSchema } from './dateSchema';
import { numericSchema } from './numericSchema';
import { numericWeightedSchema } from './numericWeightedSchema';
import { textSchema } from './textSchema';

export const itemAggregationResultSchema = z.object({
  direction: z.enum(['DESCENDANT', 'ANCESTOR', 'SELF_OR_DESCENDANT', 'SELF_AND_DESCENDANT']),
  field: z.enum([
    'TIME_SPENT',
    'LOW_EFFORT',
    'HIGH_EFFORT',
    'EXPECTED_FINISH_DATE',
    'PROGRESS_PERCENTAGE',
  ]),
  function: z.enum(['SUM', 'MIN', 'MAX', 'AVG']),
  get result() {
    return z.union([dateSchema, numericSchema, numericWeightedSchema, textSchema]).nullish();
  },
});
